"use strict";
/**
 * Created by orehman on 2/22/2017.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var Subject_1 = require("rxjs/Subject");
var Ng2DragDropService = /** @class */ (function () {
    function Ng2DragDropService() {
        this.onDragStart = new Subject_1.Subject();
        this.onDragEnd = new Subject_1.Subject();
    }
    Ng2DragDropService.decorators = [
        { type: core_1.Injectable },
    ];
    /** @nocollapse */
    Ng2DragDropService.ctorParameters = function () { return []; };
    return Ng2DragDropService;
}());
exports.Ng2DragDropService = Ng2DragDropService;
//# sourceMappingURL=ng2-drag-drop.service.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-drag-drop/src/services/ng2-drag-drop.service.js
// module id = 203
// module chunks = 9